import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrCouponFundingSource.ts
var t = () => e("couponFundingSource");
//#endregion
export { t as useTrCouponFundingSource };
